// @flow
import React from 'react';
import {Dropdown} from '@homeaway/react-dropdown';
import './InternalTools.less';

type Props = {
    searchServiceUrl?: string,
    graphiqlUrl?: string
};

const InternalTools = ({searchServiceUrl, graphiqlUrl}: Props) => {
    const links = [
        {
            link: searchServiceUrl,
            text: 'Search Service Url',
            className: 'InternalTools__SearchServiceUrl'
        },
        {
            link: graphiqlUrl,
            text: 'GraphiQL Url',
            className: 'InternalTools__GraphiQlUrl'
        }
    ];

    return (
        <Dropdown
            id="internalTools"
            label=""
            buttonChildren={
                <span className="InternalTools__buttonText text-link">
                    {'Internal Tools'}
                </span>
            }
            className="InternalTools"
            links={links}
        />
    );
};

export default InternalTools;
